import { render, staticRenderFns } from "./ClaimUpload.vue?vue&type=template&id=6f8d768c&scoped=true"
import script from "./ClaimUpload.vue?vue&type=script&lang=js"
export * from "./ClaimUpload.vue?vue&type=script&lang=js"
import style0 from "./ClaimUpload.vue?vue&type=style&index=0&id=6f8d768c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8d768c",
  null
  
)

export default component.exports